import { type Components, type Theme } from "@mui/material/styles";

export const timelineConnector: Components<Theme>["MuiTimelineConnector"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.gray[400],
    }),
  },
};
